import React from "react";
import { MdPhone } from "react-icons/md";
const MapaUbicacion = ({ direccion, mapaUrl }) => {
  return (
    <div className="w-full md:w-1/2 p-4">
      <h2 className="text-lg font-bold ">UBICACIÓN DE LA EMPRESA</h2>
      <p className="py-2">{direccion}</p>
      <iframe
       title="Mapa de ubicación"
        src={mapaUrl}
        width="100%"
        height="300"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
      ></iframe>
       <h2 className="text-lg font-bold py-4">INFORMACIÓN</h2>
       <p className="py-2">Para todo tipo de preguntas, comentarios o inquietudes; por favor escribanos a <strong className=" hover:text-azul-oscuro">informes@cecompperu.com</strong>  </p>
       <div className="bg-celeste h-1 hover:bg-azul-oscuro"></div>
       <div className="flex flex-row justify-between items-center w-full">
        
       <div className="px-8 py-2 flex flex-row items-center gap-2">
        <MdPhone className="text-xl " /> 
        <p className=" font-medium">992100857</p>
        
        </div>
        
        <div className="px-8 py-2 flex flex-row items-center gap-2">
        <MdPhone className="text-xl " /> 
        <p className=" font-medium">989180632</p>
        
        </div>

        <div className="px-8 py-2 flex flex-row items-center gap-2">
        <MdPhone className="text-xl " /> 
        <p className=" font-medium">+51 (1) 6099440</p>
        
        </div>
       </div>
    </div>
  );
};
export default MapaUbicacion;